import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { white, highlight, borderColor } from 'styles/colors'
import { body } from 'styles/texts'
import { tokensSelector } from 'selectors'

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -5px;
`

const Tag = styled.div`
  ${body};
  display: flex;
  align-items: center;
  background-color: ${props => (props.active ? highlight : white)};
  border-radius: 4px;
  padding: 5px 10px;
  border: solid 1px ${props => (props.active ? highlight : borderColor)};
  margin: 5px;
`

const TagList = ({ className, tags = [], searchTerms }) => (
  <Wrapper className={className}>
    {tags.map(tag => (
      <Tag
        key={tag}
        active={searchTerms
          .map(term => term.toLowerCase())
          .includes(tag.toLowerCase())}>
        {tag}
      </Tag>
    ))}
  </Wrapper>
)

const mapStateToProps = state => ({
  searchTerms: tokensSelector(state) || [],
})

export default connect(mapStateToProps)(TagList)



// WEBPACK FOOTER //
// ./src/components/TagList.js